
import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputField } from '../Fields/InputField';
import { StatusBar } from '../StatusBar';

export class EnquirePanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            personId: 0,
            email: '',
            mobile: '',
            fullname: '',
            poastcode: '',
            emailValid: false,
            mobileValid: true,
            fullnameValid: false,
            postcodeValid: false,
            formValid: false,
            disabled: false,
            isError: false,
            statusText: '',
            emailMandatory: true,
            mobileMandatory: true,
        };
    }

    async onEnquireClick() {

        if (!this.state.formValid) {
            this.setState({ isError: true, statusText: 'All fields must be filled!' })
            return;
        }

        try {
            const response = await fetch('person/register', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fullname: this.state.fullname,
                    email: this.state.email,
                    mobile: this.state.mobile,
                    postcode: this.state.postcode,
                    details: this.state.details,
                })
            });

            switch (response.status) {
                case 200:
                    //const personId = await response.json();
                    this.setState({
                        personId: await response.json(),
                        isError: false,
                        statusText: "Your enquiry has been successful and you will hear from one of our representatives shortly",
                        disabled: true
                    });

                    break;

                case 400:
                    //const message = await response.json();

                    this.setState({
                        isError: true,
                        statusText: await response.json(),
                        disabled: false
                    });
                    break;
            }
        }
        catch (error) {
            this.setState({
                isError: true,
                statusText: error,
                disabled: false
            });
        }
    }

    render() {
        let { emailMandatory, mobileMandatory } = this.state;
        let width = '182px'
        return (
            <Fragment>

                {ArcaHttpSystem.IsSmartphone
                    ? <Fragment>
                        <Row id='enquire'>
                            <Col xs='2'>
                            </Col>
                            <Col xs='8'>
                                <h2 id="tabelLabel">Enquire</h2>
                            </Col>
                            <Col xs='2'>
                            </Col>
                        </Row>

                    </Fragment>
                    : <Row id='enquire'>
                        <Col xs='2'>
                        </Col>
                        <Col xs='2'>
                            <h2 id="tabelLabel">Enquire</h2>
                        </Col>
                        <Col xs='6'>
                        </Col>
                        <Col xs='2'>
                        </Col>
                    </Row>}

                <Row>
                    <Col xs='2'>
                    </Col>

                    <Col xs='8'>
                        <InputField
                            label='Full Name'
                            fieldname='Full Name'
                            regularExpression='fullname'
                            warnText='Invalid name format'
                            mandatory={true}
                            onUpdate={this.fullnameCallback.bind(this)}
                            fieldValid={this.state.fullnameValid}
                            prependWidth={width}
                            fieldClass='simpleInputField ' />
                        <InputField
                            label="Email Address"
                            fieldname="Email Address"
                            regularExpression='email'
                            warnText='Invalid email format'
                            mandatory={emailMandatory}
                            value={this.state.email}
                            onUpdate={this.emailCallback.bind(this)}
                            fieldValid={this.state.emailValid}
                            prependWidth={width}
                            fieldClass='simpleInputField ' />
                        <InputField
                            label='Mobile Number'
                            fieldname='Mobile Number'
                            regularExpression='phone'
                            warnText='Invalid UK number'
                            mandatory={mobileMandatory}
                            value={this.state.mobile}
                            onUpdate={this.mobileCallback.bind(this)}
                            fieldValid={this.state.mobileValid}
                            prependWidth={width}
                            fieldClass='simpleInputField ' />
                        <InputField
                            label='Post code'
                            fieldname='Post code'
                            regularExpression='postcode'
                            warnText='Invalid UK postcode'
                            mandatory={true}
                            value={this.state.postcode}
                            onUpdate={this.postcodeCallback.bind(this)}
                            fieldValid={this.state.postcodeValid}
                            prependWidth={width}
                            fieldClass='simpleInputField' />
                        <InputField
                            label='Further details'
                            fieldname='Further details'
                            regularExpression='postcode'
                            mandatory={false}
                            value={this.state.furtherDetails}
                            onUpdate={this.detailsCallback.bind(this)}
                            fieldValid={true}
                            prependWidth={width}
                            fieldType='textarea'
                            description='Please indicate whether you wish to be a walker or if you are an owner'
                            fieldClass='simpleInputField'
                        />
                    </Col>
                    <Col xs='2'>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        {'  '}
                    </Col>
                </Row>
                <Row>
                    <Col xs='2'>
                    </Col>
                    <Col xs='8'>
                        <ArcaLink width='100%' onClick={this.onEnquireClick.bind(this)} disabled={!this.state.formValid || this.state.disabled} text='Submit' />
                        <StatusBar isError={this.state.isError} message={this.state.statusText} />

                        <ArcaLink colour='secondary' text='Forgotten' link={'/Forgotten'} width='100%' />
                    </Col>
                    <Col xs='2'>
                    </Col>
                </Row>

            </Fragment>
        );
    }



    formIsValid() {
        let { fullnameValid, emailValid, mobileValid, postcodeValid } = this.state;
        return fullnameValid && (emailValid || mobileValid) && postcodeValid;
    }

    fullnameCallback(fullname, isValid) {
        this.state.fullnameValid = isValid;

        this.setState({
            fullname: fullname,
            fullnameValid: isValid,
            formValid: this.formIsValid()
        });
    }

    detailsCallback(details, isValid) {

        this.setState({
            details,
        });
    }

    emailCallback(email, isValid) {
        this.state.emailValid = isValid;

        this.setState({
            email: email,
            emailValid: isValid,
            mobileMandatory: !isValid,
            emailMandatory: isValid,
            formValid: this.formIsValid()
        });
    }

    mobileCallback(mobile, isValid) {
        this.state.mobileValid = isValid;

        this.setState({
            mobile: mobile,
            mobileValid: isValid,
            mobileMandatory: isValid,
            emailMandatory: !isValid,
            formValid: this.formIsValid()
        });
    }

    postcodeCallback(postcode, isValid) {
        this.state.postcodeValid = isValid;

        this.setState({
            postcode: postcode,
            postcodeValid: isValid,
            formValid: this.formIsValid()
        });
    }
}
